import deviceMenu from '@js/common/deviceMenu.js';
import { appendSVGBtn, headeraddClass, initHeaderAnimation, initHomeHeroAnimation } from '@js/common/customFunctions.js';
import { initAOS } from '@js/common/aos.js';

/* Process buttons */
export const processButtons = (root = document) => {
	root.querySelectorAll('.btn-link, .btn-play, .mh-header-btn, .mejs-overlay-button, a').forEach(function (element) {
		if (element.dataset.svgAppended) return;
		element.dataset.svgAppended = 'true';

		if (element.classList.contains('btn-link')) {
			appendSVGBtn(element, '#icon-site', '24', '15');
		} else if (element.classList.contains('mh-header-btn')) {
			appendSVGBtn(element, '#icon-btn-arrow', '24', '15');
		} else if (element.classList.contains('btn-play')) {
			appendSVGBtn(element, '#icon-play', '10', '13');
		} else if (element.classList.contains('mejs-overlay-button')) {
			appendSVGBtn(element, '#icon-play', '10', '13');
		} else if (element.classList.contains('heateor_sss_button_linkedin')) {
			appendSVGBtn(element, '#icon-linkdin', '22', '22');
		} else if (element.classList.contains('heateor_sss_button_instagram')) {
			appendSVGBtn(element, '#icon-instagram', '20', '19');
		} else if (element.classList.contains('heateor_sss_facebook')) {
			appendSVGBtn(element, '#icon-facebook', '11', '22');
		} else if (element.classList.contains('heateor_sss_more')) {
			appendSVGBtn(element, '#icon-share', '16', '23');
		}
	});
};

/* Script on ready
------------------------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
	/* Initialize mobile menu */
	deviceMenu();

	/* Initialize AOS */
	initAOS();

	/* Process buttons */
	processButtons();

	/* Initialize header scroll class */
	headeraddClass();

	/* Initialize homepage header animation listener */
	initHeaderAnimation();

	/* Initialize home hero animation listener */
	initHomeHeroAnimation();
});

// MediaElement players initialize asynchronously after DOMContentLoaded
window.addEventListener('load', () => {
	processButtons();
});

// MutationObserver to automatically catch MediaElement when injected into the DOM
if (typeof MutationObserver !== 'undefined') {
	const observer = new MutationObserver(() => {
		processButtons();
	});

	if (document.body) {
		observer.observe(document.body, { childList: true, subtree: true });
	} else {
		document.addEventListener('DOMContentLoaded', () => {
			observer.observe(document.body, { childList: true, subtree: true });
		});
	}
}


/* TABLE RESPONSIVE SCRIPT WITH RESIZE SUPPORT */
function wrapTables() {
	document.querySelectorAll('.wysiwyg-component table, .accordion-component table').forEach(function (table) {
		if (!table.parentElement.classList.contains('table-wrapper')) {
			const wrapper = document.createElement('div');
			wrapper.className = 'table-wrapper';
			table.parentNode.insertBefore(wrapper, table);
			wrapper.appendChild(table);
		}
	});
}

function buildMobileTableView(wrapper) {
	const table = wrapper.querySelector('table');
	if (!table || wrapper.querySelector('.mobile-table-view')) return;

	const rows = table.querySelectorAll('tbody tr');
	if (rows.length === 0) return;

	const numColumns = rows[0].children.length;
	const columns = Array.from({ length: numColumns }, () => []);

	rows.forEach((row, rowIndex) => {
		Array.from(row.children).forEach((cell, colIndex) => {
			columns[colIndex].push({
				isHeader: rowIndex === 0,
				content: cell.innerHTML.trim()
			});
		});
	});

	const mobileView = document.createElement('div');
	mobileView.className = 'mobile-table-view';

	columns.forEach((colData) => {
		const colBlock = document.createElement('div');
		colBlock.className = 'column-block';

		colData.forEach((cell, index) => {
			const div = document.createElement('div');
			div.className = cell.isHeader ? 'column-header' : 'column-cell';
			div.innerHTML = cell.content;
			colBlock.appendChild(div);
		});

		mobileView.appendChild(colBlock);
	});

	table.insertAdjacentElement("afterend", mobileView);
}

function handleResponsiveTables() {
	wrapTables();

	document.querySelectorAll('.table-wrapper').forEach(wrapper => {
		const isMobile = window.innerWidth <= 992;
		const hasMobileView = wrapper.querySelector('.mobile-table-view');

		if (isMobile && !hasMobileView) {
			buildMobileTableView(wrapper);
		}

		if (!isMobile && hasMobileView) {
			wrapper.querySelector('.mobile-table-view').remove();
		}
	});
}

window.addEventListener("DOMContentLoaded", handleResponsiveTables);
window.addEventListener("resize", () => {
	clearTimeout(window._tableResizeTimeout);
	window._tableResizeTimeout = setTimeout(handleResponsiveTables, 200);
});
/* TABLE RESPONSIVE SCRIPT WITH RESIZE SUPPORT */

/* Header Search */
document.querySelector('.mh-search-btn')?.addEventListener('click', function () {
	this.parentElement.classList.add('is-show');
	document.body.classList.add('position-lock');

	setTimeout(() => {
		document.querySelector('.h-search-field input[type="search"]')?.focus();
	}, 100);
});

document.querySelector('.search-close')?.addEventListener('click', function () {
	document.querySelector('.mh-header-search')?.classList.remove('is-show');
	document.body.classList.remove('position-lock');
});

document.addEventListener('click', function (e) {
	if (!e.target.closest('.mh-search-btn, .mh-search-form-wrap')) {
		document.querySelector('.mh-header-search')?.classList.remove('is-show');
		document.body.classList.remove('position-lock');
	}
});
/* Header Search End */

/* Mega Menu Interactions */
(() => {
	const megaParents = document.querySelectorAll('.mega-menu-parent');
	if (!megaParents.length) return;

	const closeAll = () => {
		megaParents.forEach((p) => p.classList.remove('is-open'));
	};

	megaParents.forEach((parent) => {
		// Keyboard accessibility — toggle on Enter/Space
		const topLink = parent.querySelector(':scope > a');
		if (topLink) {
			topLink.addEventListener('keydown', (e) => {
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault();
					const wasOpen = parent.classList.contains('is-open');
					closeAll();
					if (!wasOpen) {
						parent.classList.add('is-open');
					}
				}
			});
		}
	});

	// Close on Escape anywhere
	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') {
			closeAll();
		}
	});

	// Close when clicking outside
	document.addEventListener('click', (e) => {
		if (!e.target.closest('.mega-menu-parent')) {
			closeAll();
		}
	});
})();
/* Mega Menu Interactions End */


/* Use jQuery code Start
------------------------------------------------------------------------------*/

(($) => {
	if (!$) return;

	/* Tab outline & keyboard menu navigation */
	$(document).on('keyup', 'a, button', function (e) {
		const code = e.keyCode || e.which;
		if (code === 9 || e.key === 'Tab') {
			const $this = $(this);

			if (!$this.closest('nav').length) {
				$('.menu-focus').removeClass('menu-focus');
			}

			$('.tab-outline').removeClass('tab-outline');
			$this.addClass('tab-outline');

			const $parentLi = $this.parent('li');
			if ($parentLi.find('ul').length > 0) {
				$parentLi.addClass('menu-focus').siblings().removeClass('menu-focus');
			} else {
				if (!$this.closest('.menu-item-has-children').hasClass('menu-focus')) {
					$('.menu-focus').removeClass('menu-focus');
				}
			}
		}
	});

	$(document).on('blur', 'a, button', function () {
		$(this).removeClass('tab-outline');
	});

	$(document).on('mousedown', function () {
		$('.tab-outline').removeClass('tab-outline');
		$('.menu-focus').removeClass('menu-focus');
	});
})(window.jQuery || jQuery);

/* ------------------------------------------------------------------------------
Use jQuery code End */